<template>
    <v-dialog persistent no-click-animation v-model="show" :width="400">
        <div class="ScenarioBackupEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('scenarioBackup') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <v-form ref="form" v-model="formValid" @submit="submit">
                <div class="px-10 py-10">
                    <v-textarea
                        v-model="model.description"
                        :rules="[formRules.ruleRequired, ruleMaxLength]"
                        :placeholder="$f.tc('enterDescription')"
                        rows="3"
                        spellcheck="false"
                        class="textarea-custom"
                    ></v-textarea>
                </div>
            </v-form>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-primary mr-8"
                     @click="submit">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline-secondary" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormRules from "@/modules/fptai/utils/FormRules";
import {AppServiceEventBus, AppServiceEventBusType} from "@/eventbus/appservice.eventbus";

export default {
    name: 'ScenarioBackupEditor',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            maxLength: 250,
            model: {
                description: ''
            }
        }
    },
    methods: {
        open() {
            this.clearForm()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm() {
            this.promise.resolve(this.model)
            this.close()
        },
        cancel() {
            this.show = false
            this.promise.reject(false)
        },
        ruleMaxLength (value) {
            if (!value) {
                return true
            }
            let check = value.length < this.maxLength
            return check || this.$t('formRules.fieldTooLong', [this.maxLength])
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioBackupEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

.textarea-custom {
    &.error--text {
        ::v-deep .v-input__slot {
            border: 1px solid #ff5252 !important;
        }
    }
    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        //position: absolute;
        //right: 10px !important;
        //top: 11px !important;
        margin: 6px 0 0 0;
    }

    .v-input input {
        height: 36px;
    }

    textarea {
        padding: 8px 10px !important;
    }
}
</style>
